import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextareaQuestion } from 'core/index';
import { Location } from '@angular/common';
import { ToastService } from 'core/services/toast.service';
import { Message } from '../message';
import { MessagesService } from '../messages.service';

@Component({
  selector: 'lms-message-create',
  templateUrl: './message-create.component.html',
  styleUrls: ['./message-create.component.scss']
})
export class MessageCreateComponent {
  @Input() groupId: string;
  @Input() listId: string;
  public message: any;
  public textarea: TextareaQuestion;
  @Output() messageCreated: EventEmitter<Message> = new EventEmitter<Message>();

  constructor(public location: Location, private messagesService: MessagesService, public toastService: ToastService) {}

  sendMessage() {
    const payload = {
      groupId: this.groupId,
      message: this.message
    };

    this.message = null;
    this.messagesService
      .create(payload)
      .then((message) => {
        this.messageCreated.emit(message);
        this.toastService.showOk('', '', '');
      })
      .catch((error) => {
        this.toastService.showError(error, '', '');
        this.message = payload.message;
      });
  }
}
